import { render, staticRenderFns } from "./KETBuschtrommel.vue?vue&type=template&id=50c66d2a&"
import script from "./KETBuschtrommel.vue?vue&type=script&lang=js&"
export * from "./KETBuschtrommel.vue?vue&type=script&lang=js&"
import style0 from "./KETBuschtrommel.vue?vue&type=style&index=0&id=50c66d2a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports